import InputField from "components/common/Input/Input";
import SelectOption from "components/common/Select/Select";
import React, { useEffect, useMemo, useState } from "react";
import { parseBooleanVal } from "Utils/utils";
import {
  formatAppliedRateExact,
  resolveBillingParticipantCount,
  resolveCatalogueRate,
} from "../../../utils/codeAllocationRates";
import { getItemNumberOptionsSignature } from "../../../utils/breakdownFormHydration";

import { toast } from "react-toastify";
import { apiPostRequest } from "../../../../../../helpers/Requests";
import { URL_ROSTER_LINK_TO_CORE_FUNDING } from "../../../../../../store/services/URL";
import {
  CORE_CATEGORIES,
  getLineItemLabel,
  getParticipantLabel,
} from "../../../../../../Constants/constant";

const NDISItem = ({
  itemNumber,
  setNDISItemName,
  ndisItemName,
  loading,
  setValue,
  register,
  control,
  errors,
  watchFormData,
  isTimesheetServiceCatNonSTA,
  shiftDetails,
  spSettings,
  clearErrors,
  isDisabled,
  serviceCategory,
  spRosteringSetting,
  isNonBillable,
  careSector,
}) => {
  const lineItemLabel = getLineItemLabel(careSector ?? spSettings?.care_sector) || "Support item";
  const participantLabelPlural = getParticipantLabel(careSector ?? spSettings?.care_sector, true);

     useEffect(() => {
        if (isNonBillable) {
          setValue(`rate_amount`, 0);
          setValue(`invoice_ndis_rate`, 0);
        }
      }, [isNonBillable]);
  useEffect(() => {

    if (ndisItemName?.number) {
      setValue("invoice_item_name", ndisItemName?.number);
    }
  }, [ndisItemName?.number]);
  useEffect(() => {

    if (shiftDetails && !watchFormData.rate_amount) {

      if (watchFormData.invoice_ndis_rate !== "alternate") {
        if (watchFormData.invoice_ndis_rate) {
          setValue("rate_amount", watchFormData?.invoice_ndis_rate);
        }
      } else if (watchFormData.invoice_ndis_rate === "alternate") {
        setValue("rate_amount", spSettings?.default_alternate_rate || "");
      }
    } else if (watchFormData?.rate_amount) {
      if( watchFormData?.invoice_ndis_rate === "alternate") {
        setValue("rate_amount", watchFormData?.rate_amount);
        setValue("invoice_ndis_rate", "alternate");
      } else{
 setValue("rate_amount", watchFormData?.invoice_ndis_rate);
      }
     

    }
  }, [shiftDetails, watchFormData?.invoice_ndis_rate]);
  const NDIS_RATE = [
    {
      label: "Apply Alternative Rate",
      value: "alternate",
    },
    {
      label: ndisItemName && ndisItemName?.price,
      value: ndisItemName && ndisItemName?.price,
    },
  ];
  const getAppliedAmount = () => {
    if (
      !watchFormData ||
      !shiftDetails?.participants?.length
    ) {
      return "";
    }

    const billRate = resolveCatalogueRate(
      watchFormData?.invoice_ndis_rate,
      watchFormData?.rate_amount,
      ndisItemName?.price
    );

    return formatAppliedRateExact(
      billRate / resolveBillingParticipantCount(shiftDetails)
    );
  };

  useEffect(() => {

    if (ndisItemName && ndisItemName !== null && ndisItemName.value) {
      setValue("invoice_item_id", ndisItemName.value);
      if (parseBooleanVal(spSettings?.apply_alternate_rate)) {
        setValue("invoice_ndis_rate", "alternate");
        setValue("rate_amount", spSettings?.default_alternate_rate || 0);
      }
      else {
        if(ndisItemName?.is_alternate && ndisItemName?.alternate_price){
          setValue("invoice_ndis_rate", "alternate");
          setValue("rate_amount", ndisItemName?.alternate_price);
        }else{
             if (ndisItemName?.price) {
   

          setValue("invoice_ndis_rate", ndisItemName.price);
        }
        }
     
      }
      clearErrors("invoice_item_id");
    }
  }, [ndisItemName]);

    const [budgetCheckResults, setBudgetCheckResults] = useState([]);
    const [successfulBudgetChecks, setSuccessfulBudgetChecks] = useState([]);
    const [isCheckingBudget, setIsCheckingBudget] = useState(false);
  const budgetCheckAttemptedKeyRef = React.useRef(null);
  const budgetCheckRequestIdRef = React.useRef(0);
  const isApprovedForSnapshot =
    String(shiftDetails?.status || "").toLowerCase() === "approved" ||
    String(shiftDetails?.progress || "").toLowerCase() === "pay_approved";
  const itemNumberSignature = useMemo(
    () => getItemNumberOptionsSignature(itemNumber),
    [itemNumber]
  );
  const linkRosteringCoreFunding = Boolean(
    spSettings?.link_rostering_core_funding
  );

    const checkPlanBudget = async (ndisItemId, participantId, participantName) => {
    if (
      !linkRosteringCoreFunding ||
      !ndisItemId || !participantId
    ) {
      return { success: true };
    }
    const payload = {
      price_catalog_id: ndisItemId,
      pt_id: participantId,
      timesheet_date: shiftDetails?.time_sheet_date ?? null,
      timesheet_id: shiftDetails?.id ?? null,
      timesheet_uuid: shiftDetails?.uuid ?? null,
      prefer_snapshot: isApprovedForSnapshot,
    };
    try {
      const response = await apiPostRequest(URL_ROSTER_LINK_TO_CORE_FUNDING, payload);

      if (response?.status === 200) {
        const resultMap = response?.data?.data?.items?.results || {};
        const raw = resultMap?.[participantId] ?? resultMap?.[String(participantId)];
        if (!raw) {
          const errors = response?.data?.data?.items?.errors;
          return {
            success: false,
            participantName,
            participantId,
            error:
              (Array.isArray(errors) && errors.length ? errors.join(" ") : null) ||
              "No linked funding found for this participant and line item.",
          };
        }
        const result = {
          success: true,
          participantName,
          data: raw?.ssb ?? raw,   // ssb key = new API; fallback = legacy shape
          funding: {
            contract_id: raw?.contract_id ?? null,
            start_date:  raw?.start_date  ?? null,
            end_date:    raw?.end_date    ?? null,
          },
        };
        return result;
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Budget check failed";
      const errorResult = {
        success: false,
        participantName,
        participantId,
        error: errorMessage
      };
      return errorResult;
    }
  };
  const formatParticipantName = (str) => {
    return str?.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ') || '';
  };

useEffect(() => {
  const currentItemId =
    watchFormData?.invoice_item_id ?? ndisItemName?.value ?? null;
  const checkKey = `${shiftDetails?.uuid ?? ""}|${currentItemId ?? ""}`;

  if (!currentItemId || !serviceCategory?.name) {
    return;
  }

  if (!shiftDetails?.participants || shiftDetails?.participants?.length === 0) {
    return;
  }

  const selectedInOptions = itemNumber?.find(
    (item) => String(item?.value) === String(currentItemId)
  );
  const selectedMatchesNdis =
    ndisItemName?.value != null &&
    String(ndisItemName.value) === String(currentItemId);
  if (!selectedInOptions && !selectedMatchesNdis) {
    return;
  }

  if (!linkRosteringCoreFunding) {
    return;
  }

  // One check per timesheet + line item (avoids re-firing when options re-render).
  if (budgetCheckAttemptedKeyRef.current === checkKey) {
    return;
  }
  budgetCheckAttemptedKeyRef.current = checkKey;
  const requestId = ++budgetCheckRequestIdRef.current;

  const checkInitialSelectedItem = async () => {
    setBudgetCheckResults([]);
    setSuccessfulBudgetChecks([]);
    setIsCheckingBudget(true);
    const checkResults = [];

    try {
      if (shiftDetails?.participants?.length > 1) {
        const checkPromises = shiftDetails.participants.map((participant) => {
          if (participant?.id) {
            const participantName = `${participant?.first_name || ''} ${participant?.last_name || ''}`.trim();
            return checkPlanBudget(currentItemId, participant?.id, participantName);
          }
          return Promise.resolve({ success: true });
        });
        const results = await Promise.all(checkPromises);
        checkResults.push(...results.filter(r => r !== null));
      } else {
        const participant = shiftDetails.participants[0];
        if (participant?.id) {
          const participantName = `${participant?.first_name || ''} ${participant?.last_name || ''}`.trim();
          const result = await checkPlanBudget(currentItemId, participant?.id, participantName);
          checkResults.push(result);
        }
      }

      if (budgetCheckRequestIdRef.current !== requestId) {
        return;
      }

      const failedChecks = checkResults.filter(r => !r?.success);
      const passedChecks = checkResults.filter(r => r?.success && r?.data);

      setBudgetCheckResults(failedChecks);
      setSuccessfulBudgetChecks(passedChecks);
    } finally {
      if (budgetCheckRequestIdRef.current === requestId) {
        setIsCheckingBudget(false);
      }
    }
  };

  checkInitialSelectedItem();
}, [
  watchFormData?.invoice_item_id,
  ndisItemName?.value,
  shiftDetails?.uuid,
  serviceCategory?.name,
  itemNumberSignature,
  linkRosteringCoreFunding,
  shiftDetails?.participants?.length,
]);
  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="flex flex-col gap-3 flex-1">
        <label className="ca-field-label--dark">
          {lineItemLabel} name <span className="text-red-500">*</span>
        </label>
          <div className='w-full'>
            <div className='hidden'>
              <select
                {...register("invoice_item_id", {
                  required: !isTimesheetServiceCatNonSTA ? false : true,
                })}
                name='invoice_item_id'
                id=''
                className='hidden did-floating-input'
                defaultValue={false}
              />
            </div>
            <SelectOption
              isSearch={true}
              useMenuPortal={true}
              data={itemNumber}
              selectedOption={ndisItemName}
              handleChange={async (e) => {
                setNDISItemName(e);
                setBudgetCheckResults([]);
                setSuccessfulBudgetChecks([]);
                budgetCheckAttemptedKeyRef.current = `${shiftDetails?.uuid ?? ""}|${e?.value ?? ""}`;
                if (
                  !serviceCategory?.name ||
                  !CORE_CATEGORIES?.includes(serviceCategory?.name)
                ) {
                  return;
                }
                if (!shiftDetails?.participants || shiftDetails?.participants?.length === 0) {
                  return;
                }
                setIsCheckingBudget(true);
                const checkResults = [];
                if (shiftDetails?.participants?.length > 1) {
                    const checkPromises = shiftDetails.participants.map((participant, idx) => {
                    if (participant?.id) {
                      const participantName = `${participant?.first_name || ''} ${participant?.last_name || ''}`.trim();
                      return checkPlanBudget(e?.value, participant?.id, participantName);
                    }
                    return Promise.resolve({ success: true });
                  });
                  const results = await Promise.all(checkPromises);
                  checkResults.push(...results.filter(r => r !== null));
                } else {
                  const participant = shiftDetails.participants[0];
                  if (participant?.id) {
                    const participantName = `${participant?.first_name || ''} ${participant?.last_name || ''}`.trim();
                    const result = await checkPlanBudget(e?.value, participant?.id, participantName);
                    checkResults.push(result);
                  }
                }
                const failedChecks = checkResults.filter(r => !r?.success);
                const passedChecks = checkResults.filter(r => r?.success && r?.data);
                setBudgetCheckResults(failedChecks);
                setSuccessfulBudgetChecks(passedChecks);
                if (failedChecks.length > 0) {
                  if (failedChecks.length === 1) {
                    toast.error(failedChecks[0].error);
                  } else {
                    const affectedParticipants = failedChecks.map(f => formatParticipantName(f.participantName)).join(', ');
                    toast.error(`Budget check failed for ${participantLabelPlural.toLowerCase()}: ${affectedParticipants}`);
                  }
                }
                setIsCheckingBudget(false);
              }}
              isDisabled={loading || !isTimesheetServiceCatNonSTA || isDisabled}
              loading={loading}
            />
            {errors.invoice_item_id && (
              <span className=' text-sm text-red-500'>
                This field is required
              </span>
            )}
          </div>

{isCheckingBudget && (
            <p className="ca-budget-checking">Checking budget availability...</p>
          )}

          {budgetCheckResults.length > 0 && (
            <div className="ca-budget-error">
              <p className="ca-budget-error-title">Budget Check Issues:</p>
              <ul className="ca-budget-error-list">
                {budgetCheckResults.map((result, idx) => (
                  <li key={idx}>
                    <strong>{formatParticipantName(result?.participantName)}:</strong>{" "}
                    {result.error}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {successfulBudgetChecks.length > 0 && (
            <div className="ca-budget-success">
              <p className="ca-budget-success-text font-semibold mb-1">
                Budget Available:
              </p>
              <div className="ca-budget-success-text space-y-2">
                {successfulBudgetChecks.map((result, idx) => (
                  <div key={idx} className="border-b border-green-800/50 pb-2 last:border-0">
                    <p className="font-medium">
                      {formatParticipantName(result?.participantName)}
                      {result?.funding?.contract_id && (
                        <span className="font-normal">
                          {`'s funding id # `}<strong>{result.funding.contract_id}</strong>
                        </span>
                      )}
                    </p>
                    <div className="text-xs space-y-1 mt-1">
                        <p>• Remaining Budget: ${parseFloat(result?.data?.remain_amount || '0').toFixed(2)}</p>
                        {result?.data?.unit === "E" ?
                          <p>• Remaining Quantity: {result.data?.remain_quantity}</p> :
                          <p>• Remaining Time: {result?.data?.remain_total_hours || 0}h {result?.data?.remain_total_mint || 0}m</p>
                        }
                      </div>
                  </div>

                ))}
              </div>
            </div>
          )}

          <div className="ca-breakdown-fields-grid ca-breakdown-fields-grid--2">
            <div className="flex flex-col gap-2 flex-1">
              <label className="ca-field-label--dark">
                {careSector === "aged_care" || spSettings?.care_sector === "aged_care"
                  ? "Service type number"
                  : "Support item number"}
              </label>
              <InputField
                isDisabled={true || !isTimesheetServiceCatNonSTA ||isDisabled}
                cssClass='mt-0 h-40-important text-gray-700'
                inputWidth='w-full'
                type='text'
                name='invoice_item_name'
                isRequired={!isTimesheetServiceCatNonSTA ? false : true}
                register={register}
                setValue={setValue}
                backgroundColor='#F3F4F6'
              />
            </div>
            <div className="flex flex-col gap-2 flex-1">
              <label className="ca-field-label">Hourly Rate</label>
              <SelectOption
                useMenuPortal={true}
                name='invoice_ndis_rate'
                isDisabled={
                  itemNumber?.length === 0 ||
                  watchFormData?.non_billable ||
                  loading ||
                  !ndisItemName?.value ||
                  !isTimesheetServiceCatNonSTA  || isDisabled
                }
                cssClass='w-full'
                loading={loading}
                data={NDIS_RATE}
                isRequired={!isTimesheetServiceCatNonSTA ? false : true}
                register={register}
                setValue={setValue}
                selectedOption={
                  watchFormData?.invoice_ndis_rate &&
                  NDIS_RATE?.find(
                    (x) => x.value === watchFormData?.invoice_ndis_rate
                  )
                }
              />
            </div>
          </div>
        </div>
        <div className="ca-breakdown-fields-grid ca-breakdown-fields-grid--2">
          <div className="flex flex-col gap-2 flex-1">
            <label className="ca-field-label">
              Rate Amount <span className="text-red-500">*</span>
            </label>
              {watchFormData?.invoice_ndis_rate === "alternate" ? (
                <InputField
                  isDisabled={
                    watchFormData?.non_billable || !isTimesheetServiceCatNonSTA || isDisabled
                  }
                  backgroundColor='#F3F4F6'
                  cssClass='mt-0 h-40-important text-gray-700'
                  inputWidth='w-full'
                  value={watchFormData?.rate_amount}
                  name='rate_amount'
                  isRequired={!isTimesheetServiceCatNonSTA ? false : true}
                  type='number'
                  register={register}
                  step='0.01'
                />
              ) : (
                <InputField
                  readOnly={true || !isTimesheetServiceCatNonSTA || isDisabled}
                  cssClass='mt-0 h-40-important text-gray-700'
                  isMedication
                  inputWidth='w-full'
                  name='rate_amount'
                  backgroundColor='#F3F4F6'
                  isRequired={!isTimesheetServiceCatNonSTA ? false : true}
                  register={register}
                  setValue={setValue}
                />
              )}
            </div>
            <div className="flex flex-col gap-2 flex-1">
              <label className="ca-field-label">
                Applied Rate <span className="text-red-500">*</span>
              </label>
              <InputField
                isDisabled={true || isTimesheetServiceCatNonSTA}
                cssClass='mt-0 h-40-important text-gray-700'
                inputWidth='w-full'
                backgroundColor='#F3F4F6'
                value={getAppliedAmount()}
                name='applied_rate'
              />
            </div>
          </div>
    </div>
  );
};

export default NDISItem;
